import React, { Suspense, useCallback } from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';
import Loader from '@/components/Loader';
import { EntityMediaFragment } from '@/features/messages/graphql/fragments/generated/MediaType';
import Video from '@/modules/corporate/modules/course/views/CourseDetails/components/Video';
import dynamic from '@/utils/dynamic';

import { videoMaxWidth } from './style';

const videoOverrides = {
  Video: {
    controls: false,
  },
};

const MediaPlayer = dynamic(
  () =>
    import(
      /* webpackChunkName: "media-player-module" */
      '@/components/MediaPlayer'
    ),
);

const VideoWithPreview = ({ media }: { media: EntityMediaFragment }) => {
  const [isMediaPlayerOpen, { toggle: toggleMediaPlayer }] = useToggle(false);

  const onClick = useCallback(() => {
    toggleMediaPlayer();
  }, [toggleMediaPlayer]);

  if (!media.url) {
    return null;
  }

  return (
    <>
      <Box className={cn('relative', videoMaxWidth)}>
        <Video className="pointer-events-none" overrides={videoOverrides} src={media.url!} />
        <Box className="absolute inset-0 cursor-pointer" onClick={onClick} />
      </Box>
      {isMediaPlayerOpen ? (
        <Suspense fallback={<Loader />}>
          <MediaPlayer
            initialPageNumber={1}
            isDownloadable={true}
            medias={[media]}
            onClose={toggleMediaPlayer}
          />
        </Suspense>
      ) : null}
    </>
  );
};

export default VideoWithPreview;
